export enum COLOR_TYPE {
  red = 'red',
  green = 'green',
  blue = 'blue'
}

export interface PromotionProductType {
  activeColor: COLOR_TYPE
  colors: Record<COLOR_TYPE, { id: string, added: boolean, qty: number }[]>
}

export interface ColorItmes {
  color: COLOR_TYPE,
  variant: string,
  name: string
}
